/**
 * O componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el = $(el);
const $btnClose = $el.find('.btn-close');
const $iframe   = $el.find('.iframe-faq');

$el.on('open', function () {
    $body.addClass('modal-opened');

    $el.addClass('active');
});

$btnClose.on('click', function () {
    $body.removeClass('modal-opened');
    $iframe.attr('src', $iframe.attr('src'));
    $el.removeClass('active');
});
